import passmant from './passmant'

export { passmant }